import { FormikProps } from 'formik';

const getFormError = <T extends unknown>(
  form: FormikProps<T>,
  field: keyof T,
) =>
  form.touched[field] && form.errors[field] ? form.errors[field] : undefined;

export default getFormError;
